// Copyright © 2023 CATTLEytics Inc.

export const isExtraSmall = (): boolean => window.matchMedia('(min-width: 0px)').matches;
export const isSmall = (): boolean => window.matchMedia('(min-width: 576px)').matches;
export const isMedium = (): boolean => window.matchMedia('(min-width: 768px)').matches;
export const isLarge = (): boolean => window.matchMedia('(min-width: 992px)').matches;
export const isExtraLarge = (): boolean => window.matchMedia('(min-width: 1200px)').matches;
export const isExtraExtraLarge = (): boolean => window.matchMedia('(min-width: 1400px)').matches;
